module.exports = __webpack_public_path__ + "img/ic-upload-dark.259f91e8.svg";